export default __webpack_public_path__ + "static/bean-sitting-6ef77723b1760de19c5d6f0e2955c5bf.svg";